// extracted by mini-css-extract-plugin
export default {"outerWrapper":"ImageComparisonFrame_outerWrapper__VsOiR","innerWrapper":"ImageComparisonFrame_innerWrapper__d22n6","image":"ImageComparisonFrame_image__W9gqQ"};